import { notifySuccess } from "@/utils/NotificationFunctions";
import React from "react";

export const CopyClipboard = ({ link }: { link: string }) => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(link);
    notifySuccess("Link copied to clipboard");
  };
  return (
    <div className="flex flex-col gap-2 items-center">
      <p>Link to my profile: {link}</p>
      <button className="primary-action-btn" onClick={copyToClipboard}>
        Copy to clipboard
      </button>
    </div>
  );
};
